module.exports = __webpack_public_path__ + "assets/img/632700.d9a181d5.png";